import React, { PropTypes } from 'react';
import PersonList from '../PersonList';

const ObjectRelProducers = ({ object, title }) => (
    !!object.ObjProducers && !!object.ObjProducers.edges && object.ObjProducers.edges.length ? (
        <PersonList
            persons={ object.ObjProducers.edges }
            title={title}
        />
    ) : <div></div>
);

ObjectRelProducers.propTypes = {
    object: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
};

export default ObjectRelProducers;


// WEBPACK FOOTER //
// ./app/components/Object/RelPersons/Producers/ObjectRelProducers.jsx